







































































import Vue, { PropOptions } from 'vue';
import SearchBox from '@/components/util/SearchBox.vue';
import SearchResult from '@/components/util/SearchResult.vue';
import SideBarItem from './SideBarItem.vue';
import { strFuzzyMatch } from '@/class/common/util';

export default Vue.extend({
  name: 'SideBarBase',
  components: {
    SearchBox, SearchResult, SideBarItem,
  },
  props: {
    addButtonText: String,
    list: Array as PropOptions<any[]>,
    parentList: Array as PropOptions<any[]>,
    childList: Array as PropOptions<any[]>,
    enableNest: Boolean,
    enableSlideOpen: Boolean,
    enableEditIcon: Boolean,
    enableDeleteIcon: Boolean,
    setItemID: String,
    getItemID: Function,
    getItemText: Function,
    getParentID: Function,
    getParentText: Function,
    getChildID: Function,
    getChildText: Function,
    selectedTab: Number,
    // sp-nav
    isDefault: Boolean, // リスト表示: true, 詳細表示: false
    keepListSelect: Boolean, // リストに戻った時に選択中の表示にする場合はtrue
    ownerFlag: Boolean,
  },
  mounted() {
    this.$emit('selectedID', this.selectedID);
  },
  watch: {
    setItemID: {
      immediate: true,
      handler(v) {
        this.selectedID = v;
        // this.selectedItem = this.list.find(x => String(this.getItemID(x)) === v);
      },
    },
    isDefault(v) {
      this.isShowingList = v;
    },
    searchText(v) {
      this.$emit('search', v);
    },
    selectedTab() {
      this.searchText = '';
    },
  },
  data() {
    return {
      searchText: '',
      selectedID: '0',
      // selectedItem: {},
      hoverBoardFlag: false,
      hoveredBoardID: '-1',
      nearSideBarFlag: false,
      hoverSideBarFlag: false,
      sideBarShowFlag: true, // ダッシュボードでのサイドバー開閉用
      isShowingList: true, // (SPのみ)一覧表示中はtrue, 詳細表示中はfalse
      isTouchMoved: false,
    };
  },
  methods: {
    clickItem(v: any) {
      this.selectedID = this.getItemID(v);
      this.$emit('clickItem', v);
      // this.selectedItem = v;
      // this.isShowingList = false;
      // this.$emit('selected');
    },
    catchClickItemEvent(event: any) {
      this.$emit('clickItem', event);
      // this.selectedItem = event;
      // this.isShowingList = false;
      // this.$emit('selected');
    },
    clickEdit(v: any) {
      this.$emit('clickEdit', v);
    },
    clickDelete(v: any) {
      this.$emit('clickDelete', v);
    },
    toggleNearFlag(flag: boolean) {
      const delay = flag ? 0 : 100;
      setTimeout(() => {
        this.nearSideBarFlag = flag;
      }, delay);
    },
    toggleHoverFlag(flag: boolean) {
      const delay = flag ? 0 : 100;
      setTimeout(() => {
        this.hoverSideBarFlag = flag;
      }, delay);
    },
    toggleBoardHoverFlag(flag: boolean, boardID: string) {
      this.hoverBoardFlag = flag;
      this.hoveredBoardID = boardID;
    },
    matchOptionText(text: string): string | null {
      return strFuzzyMatch(this.searchText, text);
    },
    refreshDashboard() {
      this.$emit('refreshDashboard');
    },
    // iOS Safariでclickイベントが発生しないため対策
    // ドラッグしていないtouchendをタップ操作とみなしてclick時の処理を呼び出す
    onTouchMove() {
      this.isTouchMoved = true;
    },
    onTouchEnd(v: any) {
      if (!this.isTouchMoved) {
        this.clickItem(v);
        this.isTouchMoved = false;
      }
    },
  },
});
